// This file is auto-generated. Do not edit manually.

import { z } from "zod";
import { coerceBoolean } from "./utilitySchemas";

export const AppraisalDownloadQuerySchema = z.object({
  isExternalRequest: coerceBoolean(),
  });
  export type AppraisalDownloadQuery = z.infer<typeof AppraisalDownloadQuerySchema>;